import {AgentCall, Conversation} from '@stripe-internal/conversations-client';
import {AgentCard} from './index';

export type AgentCardCompatProps = {
  conversation?: Conversation;
  agentCall: AgentCall;
  messageId: string;
};

export function AgentCardCompat({
  conversation,
  agentCall,
  messageId,
}: AgentCardCompatProps) {
  if (!conversation) {
    throw new Error('Legacy AgentCard expects a conversation');
  }

  return (
    <AgentCard
      agentCall={agentCall}
      messageId={messageId}
      conversation={conversation}
    />
  );
}
